var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#102818",
    d: "m25.327 16.688-2.66-3.99A2.493 2.493 0 0 0 24 10.5c0-1.15-.784-2.111-1.844-2.402l1.105-1.843a2.107 2.107 0 0 0-.114-2.344 2.108 2.108 0 0 0-2.21-.792l-.984.247a1.001 1.001 0 0 1-.798-.139l-.75-.499a4.32 4.32 0 0 0-4.811 0l-.75.5a1.01 1.01 0 0 1-.797.138l-.986-.247a2.104 2.104 0 0 0-2.209.792 2.103 2.103 0 0 0-.114 2.344l1.105 1.843A2.497 2.497 0 0 0 7.999 10.5c0 .955.544 1.777 1.333 2.198l-2.66 3.99c-2.344 3.516-1.579 8.24 1.741 10.756 2.175 1.649 4.869 2.557 7.586 2.557s5.411-.908 7.587-2.557c3.319-2.516 4.084-7.24 1.74-10.756zM10.5 11a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1zm-.041-5.898c.047-.062.094-.049.117-.042l.986.247a3.005 3.005 0 0 0 2.392-.414l.75-.5a2.332 2.332 0 0 1 2.592 0l.75.499a3.015 3.015 0 0 0 2.393.415l.984-.247c.025-.007.07-.02.118.042.044.061.02.102.006.125L19.883 8h-7.766l-1.664-2.773c-.014-.022-.038-.064.006-.125zm11.92 20.748C20.549 27.237 18.283 28 16 28s-4.549-.764-6.378-2.15c-2.479-1.878-3.043-5.416-1.285-8.053L11.535 13h8.93l3.198 4.797c1.758 2.637 1.193 6.174-1.284 8.053z",
    opacity: 1,
    "data-original": "#102818",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33c177",
    d: "M19 21.5a2.502 2.502 0 0 1-2.01 2.45c0 .017.01.032.01.05v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h2.5a.5.5 0 0 0 0-1h-1a2.503 2.503 0 0 1-2.5-2.5c0-1.211.865-2.222 2.01-2.45 0-.017-.01-.032-.01-.05v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-2.5a.5.5 0 0 0 0 1h1c1.379 0 2.5 1.122 2.5 2.5z",
    opacity: 1,
    "data-original": "#6ac395",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.81842638f72e49bac65a96c3b4ff0615.svg";
export { ForwardRef as ReactComponent };